import { fabric } from "fabric";

export class ViewportHelper {
  private canvas: fabric.Canvas | null = null;

  constructor() {}

  public setCanvas(canvas: fabric.Canvas) {
    this.canvas = canvas;
  }

  /**
   * 检测对象是否在视口内
   */
  public isInViewport(obj: fabric.Object): boolean {
    if (!this.canvas) return false;

    const vpt = this.canvas.viewportTransform;
    if (!vpt) return false;

    const zoom = this.canvas.getZoom();
    const width = this.canvas.getWidth() / zoom;
    const height = this.canvas.getHeight() / zoom;
    const vptLeft = -vpt[4] / zoom;
    const vptTop = -vpt[5] / zoom;

    const br = obj.getBoundingRect(true, true);
    return (
      br.left < vptLeft + width &&
      br.left + br.width > vptLeft &&
      br.top < vptTop + height &&
      br.top + br.height > vptTop
    );
  }

  /**
   * 获取当前视口信息，包含检测函数
   * 避免重复计算视口变换矩阵
   */
  public getViewportInfo() {
    if (!this.canvas) return null;

    const vpt = this.canvas.viewportTransform;
    if (!vpt) return null;

    const zoom = this.canvas.getZoom();
    const width = this.canvas.getWidth() / zoom;
    const height = this.canvas.getHeight() / zoom;
    const vptLeft = -vpt[4] / zoom;
    const vptTop = -vpt[5] / zoom;

    return {
      rect: {
        left: vptLeft,
        top: vptTop,
        right: vptLeft + width,
        bottom: vptTop + height
      },
      /**
       * 检测对象是否在视口内（即使部分重叠也算）
       */
      checkInViewport: (obj: fabric.Object): boolean => {
        const br = obj.getBoundingRect(true, true);
        return (
          br.left < vptLeft + width &&
          br.left + br.width > vptLeft &&
          br.top < vptTop + height &&
          br.top + br.height > vptTop
        );
      }
    };
  }
}
